"use client";

import { useEffect, useState, Suspense, lazy } from "react";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";

// Lazy-load production devtools
const ReactQueryDevtoolsProduction = lazy(async () => {
  const module = await import(
    "@tanstack/react-query-devtools/build/modern/production.js"
  );
  return { default: module.ReactQueryDevtools };
});

// Extend the Window interface to include toggleDevtools
declare global {
  interface Window {
    toggleDevtools?: () => void;
  }
}

export default function DevToolsManager() {
  const [showDevtools, setShowDevtools] = useState(false);
  useEffect(() => {
    window.toggleDevtools = () => setShowDevtools((prev) => !prev);
    return () => {
      delete window.toggleDevtools;
    };
  }, []);

  return (
    <>
      {/* Always include default devtools */}
      <ReactQueryDevtools initialIsOpen={false} />

      {/* Conditionally render production devtools */}
      {showDevtools && (
        <Suspense fallback={null}>
          <ReactQueryDevtoolsProduction />
        </Suspense>
      )}
    </>
  );
}